import React, { useEffect } from "react"
import { ListGroup, ListGroupItem, Col, Row, Container, Alert } from "reactstrap"
import { Trans, useLingui } from "@lingui/react"
import { useSelector, useDispatch } from "react-redux"
import uuid from "uuid"
import redArrow from "../../view/assets/arrowRed.png"
import greenArrow from "../../view/assets/arrowGreen.png"
import { getCurrency } from "../../view/shared/utilities/currency"
import { setCurrentPage } from "../../store/reducers/navigation"
import { fullArabicDateConverter } from "../../view/shared/utilities/arabicDateConverter"

const MeetingItem = () => {
  const { i18n } = useLingui()
  const dispatch = useDispatch()
  const { selectedPreviousMeeting, vsla, group, transactions } = useSelector(
    (state) => ({
      transactions:
        state.previousMeetingsTransactions.selectedMeeting.transactions,
      // .filter(
      //   ({ status }) => status === "SUCCESSFUL",
      // ),
      vsla: state.vsla,
      group: state.group,
      selectedPreviousMeeting: state.previousMeetingsTransactions.selectedMeeting,
    }),
  )

  useEffect(() => {
    if (!selectedPreviousMeeting) {
      dispatch(setCurrentPage("group-previousMeetings"))
    }
  }, [])

  const dateStyle = {
    color: "#E36F1E",
    fontFamily: "quicksand",
    fontWeight: "bolder",
    fontSize: "25px",
    padding: ".5rem",
    textAlign: "center",
    margin: "34px 0 0 0",
  }

  if (transactions.length < 1) {
    return (
      <div>
        <div style={dateStyle}>
          <span>
            {!["ar"].includes(i18n.locale) &&
              new Date(selectedPreviousMeeting.date).toLocaleString(i18n.locale, {
                dateStyle: "full",
              })}

            {["ar"].includes(i18n.locale) &&
              fullArabicDateConverter(selectedPreviousMeeting.date)}
          </span>
        </div>
        <br />
        <Container>
          <Alert color="warning">
            <span>
              <Trans id="notifications.no_transactions">
                There are no transactions for this meeting
              </Trans>
            </span>
          </Alert>
        </Container>
      </div>
    )
  }

  return (
    <div>
      <div style={dateStyle}>
        <span>
          {!["ar"].includes(i18n.locale) &&
            new Date(selectedPreviousMeeting.date).toLocaleString(i18n.locale, {
              dateStyle: "full",
            })}
          {["ar"].includes(i18n.locale) &&
            fullArabicDateConverter(selectedPreviousMeeting.date)}
        </span>
      </div>
      <br />

      <Container style={{ paddingBottom: "30px" }}>
        <ListGroup flush style={{ lineHeight: "1.4em" }}>
          {transactions.map((transaction) => {
            const type = (transaction?.transactionType || transaction?.type).toLowerCase()
            return [
              "welfare_contribution",
              "loan_repayment",
              "loan_interest_repayment",
              "fine_payment",
              "group_income",
              "membership_fee",
              "buy_shares",
            ].includes(type) ? (
              type === "write_off_loan" || (
                <ListGroupItem key={uuid.v4()}>
                  <Row>
                    <Col xs="2">
                      <img
                        src={greenArrow}
                        alt="fine"
                        style={{ marginTop: "0.5em" }}
                      />
                    </Col>
                    <Col xs="10">
                      <span
                        style={{
                          color: "#02294a",
                          fontFamily: "Fira Sans",
                          fontSize: "20px",
                        }}
                      >
                        {transaction.transactionPartyName}
                      </span>
                      <br />
                      <span
                        style={{
                          color: transaction.isOffline ? "#E36F1E" : "#0fbe15",
                          fontFamily: "Fira Sans",
                          fontSize: "20px",
                        }}
                      >
                        {i18n._(type.replace(/_/g, " "))}
                        {":  "}
                        {"+"}
                        {transaction.amount}{" "}
                        {!["ar", "lb"].includes(i18n.locale) &&
                          getCurrency(group?.country).symbol}
                        {["ar", "lb"].includes(i18n.locale) &&
                          (vsla?.metadata?.currency === "USD"
                            ? getCurrency(group?.country).usd_symbol
                            : getCurrency(group?.country).lbp_symbol)}
                      </span>
                      <small style={{ display: "block", textAlign: "center", color: "#E36F1E", fontStyle: "italic", fontSize: "14px" }}>
                        {transaction.isOffline ? 'Pending sync' : ''}
                      </small>
                    </Col>
                  </Row>
                </ListGroupItem>
              )
            ) : (
              <ListGroupItem key={uuid.v4()}>
                <Row>
                  <Col xs="2">
                    <img src={redArrow} alt="fine" style={{ marginTop: "0.5em" }} />
                  </Col>
                  <Col xs="10">
                    <span
                      style={{
                        color: "#02294a",
                        fontFamily: "Fira Sans",
                        fontSize: "20px",
                      }}
                    >
                      {transaction.transactionPartyName}
                    </span>
                    <br />
                    <span
                      style={{
                        color: "#ff0707",
                        fontFamily: "Fira Sans",
                        fontSize: "20px",
                      }}
                    >
                      {i18n._(transaction.transactionType.replace(/_/g, " "))}
                      {":  "}
                      {"-"}
                      {Math.abs(transaction.amount)}{" "}
                      {!["ar", "lb"].includes(i18n.locale) &&
                        getCurrency(group?.country).symbol}
                      {["ar", "lb"].includes(i18n.locale) &&
                        (vsla?.metadata?.currency === "USD"
                          ? getCurrency(group?.country).usd_symbol
                          : getCurrency(group?.country).lbp_symbol)}
                    </span>
                  </Col>
                </Row>
              </ListGroupItem>
            )
          })}
        </ListGroup>
      </Container>
    </div>
  )
}

export default MeetingItem
